export const CONFIGURATION_TYPE = {
  USABLE: 'usable',
  DUPLICATED_AVAILABLE: 'duplicatedAvailable'
} as const;

export const TAB_TYPE = {
  CONFIGURATION: 'configuration',
  CONDITION: 'condition'
} as const;

export const KEYWORD_TYPE = {
  CONDITION_NAME: 'CONDITION_NAME',
  CONDITION_NO: 'CONDITION_NO',
  REGISTER_NAME: 'REGISTER_NAME',
  UPDATER_NAME: 'UPDATER_NAME'
} as const;

export const PERIOD_TYPE = {
  REGISTER_AT: 'REGISTER_AT',
  START_AT: 'START_AT',
  END_AT: 'END_AT',
} as const;

export const GIVE_STATUS_TYPE = {
  READY: 'READY',
  ON: 'ON',
  STOP: 'STOP',
  FINISH: 'FINISH',
} as const;

export const FREE_GIFT_STATUS_TYPE = {
  STOP: 'STOP',
  AVAILABLE: 'AVAILABLE',
  FINISH: 'FINISH',
} as const;
